import { render, staticRenderFns } from "./DataType.vue?vue&type=template&id=4e44e978&scoped=true&"
import script from "./DataType.vue?vue&type=script&lang=js&"
export * from "./DataType.vue?vue&type=script&lang=js&"
import style0 from "./DataType.vue?vue&type=style&index=0&id=4e44e978&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e44e978",
  null
  
)

export default component.exports